import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormGrid, IParams, Loading, Page } from '../../../shared';
import { StockProductDetail, StockProductLocations } from '../../components';
import { useStockProduct } from '../../hooks';

export const StockProductPage: FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<keyof IParams>() as IParams;
    const { data: stockProduct } = useStockProduct(id);

    return stockProduct ? (
        <Page title={stockProduct?.name} onBack={() => navigate(-1)}>
            <FormGrid size={{ xs: 6 }} containerProps={{ spacing: 3 }}>
                <StockProductDetail stockProduct={stockProduct} />
                <StockProductLocations stockProduct={stockProduct} />
            </FormGrid>
        </Page>
    ) : (
        <Loading />
    );
};
